var PANASONIC_A75C3712 = {
  name: "PANASONIC A75C3712",
  defaultCommandIndex: 1,
  commands: [
    {
      mode: "AC_MODE_OFF",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_NULL",
      command: [183,1,4,17,2,29,1,219,13,107,6,28,2,166,4,48,2,29,40,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,254,73,254,127,228,146,102,127,255,228,159,249,39,255,252,254,127,255,242,73,36,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_AUTO",
      command: [183,1,5,17,2,34,1,221,13,102,6,22,2,170,4,29,2,30,40,27,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,127,159,249,36,153,159,255,249,39,254,73,255,255,63,159,255,243,36,146,66],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_AUTO",
      command: [183,1,5,18,2,34,1,225,13,104,6,24,2,172,4,37,2,31,40,22,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,121,231,254,73,38,103,255,254,73,255,146,127,255,207,231,255,252,146,73,36,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_AUTO",
      command: [183,1,5,11,2,42,1,235,13,115,6,18,2,171,4,37,2,251,39,35,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,124,231,254,73,38,103,255,254,73,255,146,127,255,207,231,255,252,255,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_AUTO",
      command: [183,1,5,16,2,33,1,223,13,110,6,25,2,152,4,31,2,27,40,35,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,121,57,255,146,73,153,255,255,146,127,228,159,255,243,249,255,255,39,240,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_AUTO",
      command: [183,1,5,11,2,39,1,230,13,125,6,21,2,174,4,35,2,23,40,32,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,126,103,254,73,38,103,255,254,73,255,146,127,255,207,231,255,252,207,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_AUTO",
      command: [183,1,5,16,2,34,1,223,13,109,6,17,2,169,4,59,2,29,40,61,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,121,153,255,146,73,153,255,255,146,127,228,159,255,243,249,255,255,36,252,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_AUTO",
      command: [183,1,5,16,2,34,1,219,13,98,6,19,2,168,4,54,2,30,40,33,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,124,153,255,146,73,153,255,255,146,127,228,159,255,243,249,255,255,57,240,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_AUTO",
      command: [183,1,5,16,2,32,1,218,13,106,6,27,2,169,4,61,2,31,40,50,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,121,38,127,228,146,102,127,255,228,159,249,39,255,252,254,127,255,201,159,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_AUTO",
      command: [183,1,5,16,2,35,1,255,13,109,6,19,2,169,4,40,2,26,40,62,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,127,39,254,73,38,103,255,254,73,255,146,127,255,207,231,255,252,201,240,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_AUTO",
      command: [183,1,5,20,2,36,1,220,13,101,6,15,2,171,4,48,2,28,40,36,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,121,201,255,146,73,153,255,255,146,127,228,159,255,243,249,255,255,36,159,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_AUTO",
      command: [183,1,5,16,2,36,1,220,13,107,6,21,2,171,4,30,2,32,40,59,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,124,201,255,146,73,153,255,255,146,127,228,159,255,243,249,255,255,60,240,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_AUTO",
      command: [183,1,5,14,2,34,1,223,13,111,6,17,2,171,4,32,2,5,40,54,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,121,50,127,228,146,102,127,255,228,159,249,39,255,252,254,127,255,201,207,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_AUTO",
      command: [183,1,5,17,2,38,1,228,13,107,6,19,2,172,4,38,2,33,40,36,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,126,73,255,146,73,153,255,255,146,127,228,159,255,243,249,255,255,51,60,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_AUTO",
      command: [183,1,5,18,2,35,1,221,13,101,6,18,2,169,4,63,2,25,40,35,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,121,146,127,228,146,102,127,255,228,159,249,39,255,252,254,127,255,201,51,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_AUTO",
      command: [183,1,5,16,2,35,1,223,13,110,6,18,2,172,4,54,2,27,40,49,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,124,146,127,228,146,102,127,255,228,159,249,39,255,252,254,127,255,206,79,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_LOW",
      command: [183,1,5,20,2,34,1,219,13,81,6,26,2,171,4,33,2,33,40,15,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,127,159,249,36,146,127,255,249,39,254,73,255,255,63,159,255,243,39,144,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_LOW",
      command: [183,1,5,18,2,36,1,221,13,105,6,18,2,167,4,33,2,35,40,21,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,121,231,254,73,36,159,255,254,73,255,146,127,255,207,231,255,252,146,121,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_LOW",
      command: [183,1,5,18,2,33,1,249,13,101,6,28,2,167,4,32,2,30,40,21,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,124,231,254,73,36,159,255,254,73,255,146,127,255,207,231,255,252,243,144,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_LOW",
      command: [183,1,5,17,2,32,1,222,13,97,6,27,2,166,4,46,2,37,40,16,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,121,57,255,146,73,39,255,255,146,127,228,159,255,243,249,255,255,39,57,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_LOW",
      command: [183,1,5,16,2,34,1,235,13,109,6,24,2,168,4,43,2,247,39,27,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,126,103,254,73,36,159,255,254,73,255,146,127,255,207,231,255,252,204,228,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_LOW",
      command: [183,1,5,20,2,34,1,222,13,99,6,18,2,168,4,55,2,33,40,27,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,121,153,255,146,73,39,255,255,146,127,228,159,255,243,249,255,255,36,206,66],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_LOW",
      command: [183,1,5,18,2,35,1,225,13,99,6,23,2,168,4,55,2,27,40,19,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,124,153,255,146,73,39,255,255,146,127,228,159,255,243,249,255,255,57,57,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_LOW",
      command: [183,1,5,18,2,34,1,226,13,98,6,25,2,166,4,34,2,33,40,18,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,121,38,127,228,146,73,255,255,228,159,249,39,255,252,254,127,255,201,147,144,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_LOW",
      command: [183,1,5,17,2,31,1,216,13,109,6,28,2,167,4,37,2,29,40,19,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,127,39,254,73,36,159,255,254,73,255,146,127,255,207,231,255,252,201,57,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_LOW",
      command: [183,1,5,15,2,35,1,253,13,103,6,24,2,170,4,60,2,29,40,28,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,121,201,255,146,73,39,255,255,146,127,228,159,255,243,249,255,255,36,147,144,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_LOW",
      command: [183,1,5,19,2,34,1,221,13,101,6,27,2,169,4,37,2,35,40,24,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,124,201,255,146,73,39,255,255,146,127,228,159,255,243,249,255,255,62,100,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_LOW",
      command: [183,1,5,18,2,31,1,220,13,104,6,28,2,171,4,33,2,250,39,22,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,121,50,127,228,146,73,255,255,228,159,249,39,255,252,254,127,255,201,230,66],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_LOW",
      command: [183,1,5,18,2,34,1,216,13,98,6,17,2,168,4,32,2,35,40,18,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,126,73,255,146,73,39,255,255,146,127,228,159,255,243,249,255,255,51,153,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_LOW",
      command: [183,1,5,19,2,36,1,221,13,72,6,19,2,166,4,54,2,27,40,26,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,121,146,127,228,146,73,255,255,228,159,249,39,255,252,254,127,255,201,57,144,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_LOW",
      command: [183,1,5,17,2,33,1,250,13,106,6,29,2,170,4,37,2,32,40,22,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,124,146,127,228,146,73,255,255,228,159,249,39,255,252,254,127,255,206,102,66],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_MID",
      command: [183,1,5,16,2,34,1,221,13,104,6,30,2,168,4,27,2,32,40,25,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,127,159,249,36,147,63,255,249,39,254,73,255,255,63,159,255,243,38,100,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_MID",
      command: [183,1,5,18,2,34,1,224,13,72,6,25,2,171,4,53,2,24,40,13,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,121,231,254,73,36,207,255,254,73,255,146,127,255,207,231,255,252,146,102,66],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_MID",
      command: [183,1,5,16,2,33,1,223,13,104,6,29,2,167,4,49,2,34,40,24,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,124,231,254,73,36,207,255,254,73,255,146,127,255,207,231,255,252,242,100,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_MID",
      command: [183,1,5,20,2,34,1,233,13,99,6,29,2,168,4,36,2,7,40,26,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,121,57,255,146,73,51,255,255,146,127,228,159,255,243,249,255,255,39,38,66],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_MID",
      command: [183,1,5,19,2,35,1,250,13,100,6,18,2,169,4,39,2,24,40,19,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,126,103,254,73,36,207,255,254,73,255,146,127,255,207,231,255,252,204,153,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_MID",
      command: [183,1,5,15,2,34,1,227,13,107,6,21,2,171,4,30,2,35,40,17,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,121,153,255,146,73,51,255,255,146,127,228,159,255,243,249,255,255,36,201,144,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_MID",
      command: [183,1,5,16,2,34,1,224,13,104,6,26,2,168,4,47,2,32,40,23,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,124,153,255,146,73,51,255,255,146,127,228,159,255,243,249,255,255,57,38,66],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_MID",
      command: [183,1,5,17,2,35,1,221,13,97,6,17,2,154,4,47,2,34,40,30,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,121,38,127,228,146,76,255,255,228,159,249,39,255,252,254,127,255,201,146,100,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_MID",
      command: [183,1,5,16,2,33,1,223,13,103,6,28,2,169,4,57,2,33,40,18,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,127,39,254,73,36,207,255,254,73,255,146,127,255,207,231,255,252,201,38,66],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_MID",
      command: [183,1,5,17,2,33,1,243,13,106,6,26,2,168,4,33,2,28,40,20,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,121,201,255,146,73,51,255,255,146,127,228,159,255,243,249,255,255,36,146,100,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_MID",
      command: [183,1,5,18,2,33,1,227,13,98,6,30,2,171,4,32,2,33,40,22,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,124,201,255,146,73,51,255,255,146,127,228,159,255,243,249,255,255,63,36,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_MID",
      command: [183,1,5,17,2,34,1,242,13,99,6,18,2,170,4,40,2,28,40,20,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,121,50,127,228,146,76,255,255,228,159,249,39,255,252,254,127,255,201,242,66],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_MID",
      command: [183,1,5,1,2,35,1,227,13,124,6,31,2,169,4,34,2,26,40,19,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,126,73,255,146,73,51,255,255,146,127,228,159,255,243,249,255,255,51,201,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_MID",
      command: [183,1,5,19,2,36,1,248,13,99,6,19,2,167,4,60,2,37,40,20,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,121,146,127,228,146,76,255,255,228,159,249,39,255,252,254,127,255,201,60,144,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_MID",
      command: [183,1,5,16,2,31,1,220,13,108,6,25,2,169,4,60,2,23,40,22,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,124,146,127,228,146,76,255,255,228,159,249,39,255,252,254,127,255,206,114,66],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_HIGH",
      command: [183,1,5,17,2,34,1,227,13,106,6,19,2,169,4,47,2,28,40,27,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,127,159,249,36,146,79,255,254,73,255,146,127,255,207,231,255,252,201,201,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_HIGH",
      command: [183,1,5,18,2,33,1,218,13,96,6,19,2,169,4,46,2,28,40,19,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,121,231,254,73,36,147,255,255,146,127,228,159,255,243,249,255,255,36,156,144,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_HIGH",
      command: [183,1,5,16,2,33,1,225,13,106,6,33,2,171,4,60,2,39,40,19,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,124,231,254,73,36,147,255,255,146,127,228,159,255,243,249,255,255,60,201,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_HIGH",
      command: [183,1,5,17,2,30,1,220,13,108,6,31,2,169,4,51,2,35,40,24,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,121,57,255,146,73,36,255,255,228,159,249,39,255,252,254,127,255,201,204,144,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_HIGH",
      command: [183,1,5,16,2,36,1,219,13,107,6,27,2,170,4,54,2,32,40,17,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,126,103,254,73,36,147,255,255,146,127,228,159,255,243,249,255,255,51,50,66],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_HIGH",
      command: [183,1,5,18,2,32,1,224,13,99,6,25,2,168,4,53,2,27,40,17,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,121,153,255,146,73,36,255,255,228,159,249,39,255,252,254,127,255,201,51,36,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_HIGH",
      command: [183,1,5,18,2,32,1,218,13,99,6,23,2,169,4,37,2,32,40,19,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,124,153,255,146,73,36,255,255,228,159,249,39,255,252,254,127,255,206,76,144,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_HIGH",
      command: [183,1,5,18,2,35,1,225,13,103,6,26,2,170,4,35,2,31,40,21,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,121,38,127,228,146,73,63,255,249,39,254,73,255,255,63,159,255,242,100,201,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_HIGH",
      command: [183,1,5,16,2,36,1,227,13,99,6,18,2,169,4,32,2,29,40,29,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,127,39,254,73,36,147,255,255,146,127,228,159,255,243,249,255,255,50,76,144,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_HIGH",
      command: [183,1,5,16,2,10,1,219,13,106,6,43,2,169,4,29,2,27,40,24,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,121,201,255,146,73,36,255,255,228,159,249,39,255,252,254,127,255,201,36,201,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_HIGH",
      command: [183,1,5,18,2,34,1,220,13,101,6,25,2,172,4,37,2,37,40,24,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,124,201,255,146,73,36,255,255,228,159,249,39,255,252,254,127,255,207,146,66],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_HIGH",
      command: [183,1,5,15,2,35,1,225,13,115,6,27,2,171,4,60,2,4,40,15,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,121,50,127,228,146,73,63,255,249,39,254,73,255,255,63,159,255,242,121,36,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_HIGH",
      command: [183,1,5,16,2,31,1,227,13,108,6,27,2,172,4,36,2,36,40,25,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,126,73,255,146,73,36,255,255,228,159,249,39,255,252,254,127,255,204,228,144,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_HIGH",
      command: [183,1,5,16,2,34,1,250,13,104,6,17,2,169,4,52,2,22,40,15,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,121,146,127,228,146,73,63,255,249,39,254,73,255,255,63,159,255,242,78,73,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_HIGH",
      command: [183,1,5,14,2,34,1,250,13,114,6,16,2,169,4,32,2,39,40,16,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,146,124,146,127,228,146,73,63,255,249,39,254,73,255,255,63,159,255,243,153,36,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_AUTO",
      command: [183,1,5,16,2,34,1,250,13,98,6,28,2,172,4,35,2,37,40,20,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,254,127,228,146,102,127,255,228,159,249,39,255,252,254,127,255,204,153,36,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_AUTO",
      command: [183,1,5,17,2,35,1,245,13,110,6,17,2,170,4,36,2,26,40,22,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,231,159,249,36,153,159,255,249,39,254,73,255,255,63,159,255,242,73,146,66],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_AUTO",
      command: [183,1,5,19,2,32,1,228,13,98,6,30,2,168,4,53,2,33,40,20,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,243,159,249,36,153,159,255,249,39,254,73,255,255,63,159,255,243,201,36,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_AUTO",
      command: [183,1,5,20,2,33,1,225,13,69,6,27,2,169,4,37,2,38,40,27,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,228,231,254,73,38,103,255,254,73,255,146,127,255,207,231,255,252,156,146,66],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_AUTO",
      command: [183,1,5,16,2,36,1,225,13,102,6,21,2,173,4,52,2,248,39,19,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,249,159,249,36,153,159,255,249,39,254,73,255,255,63,159,255,243,50,73,8],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_AUTO",
      command: [183,1,5,15,2,36,1,227,13,107,6,18,2,169,4,51,2,249,39,16,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,230,103,254,73,38,103,255,254,73,255,146,127,255,207,231,255,252,147,36,144,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_AUTO",
      command: [183,1,5,19,2,33,1,225,13,98,6,22,2,169,4,37,2,22,40,16,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,242,103,254,73,38,103,255,254,73,255,146,127,255,207,231,255,252,228,146,66],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_AUTO",
      command: [183,1,5,13,2,36,1,219,13,113,6,24,2,169,4,57,2,1,40,13,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,228,153,255,146,73,153,255,255,146,127,228,159,255,243,249,255,255,38,73,36,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_AUTO",
      command: [183,1,5,14,2,34,1,227,13,109,6,15,2,169,4,49,2,36,40,16,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,252,159,249,36,153,159,255,249,39,254,73,255,255,63,159,255,243,36,146,66],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_AUTO",
      command: [183,1,5,17,2,33,1,221,13,105,6,21,2,143,4,49,2,21,40,16,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,231,39,254,73,38,103,255,254,73,255,146,127,255,207,231,255,252,146,73,36,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_AUTO",
      command: [183,1,5,19,2,35,1,220,13,98,6,29,2,167,4,35,2,27,40,61,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,243,39,254,73,38,103,255,254,73,255,146,127,255,207,231,255,252,255,8],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_AUTO",
      command: [183,1,5,19,2,35,1,225,13,101,6,19,2,169,4,35,2,36,40,33,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,228,201,255,146,73,153,255,255,146,127,228,159,255,243,249,255,255,39,240,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_AUTO",
      command: [183,1,5,15,2,31,1,220,13,112,6,33,2,171,4,43,2,7,40,56,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,249,39,254,73,38,103,255,254,73,255,146,127,255,207,231,255,252,207,194],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_AUTO",
      command: [183,1,5,17,2,33,1,1,14,101,6,28,2,170,4,37,2,28,40,33,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,230,73,255,146,73,153,255,255,146,127,228,159,255,243,249,255,255,36,252,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_AUTO",
      command: [183,1,5,15,2,36,1,228,13,105,6,23,2,174,4,37,2,31,40,35,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,242,73,255,146,73,153,255,255,146,127,228,159,255,243,249,255,255,57,240,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_LOW",
      command: [183,1,5,18,2,34,1,225,13,102,6,27,2,171,4,34,2,252,39,56,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,254,127,228,146,73,255,255,228,159,249,39,255,252,254,127,255,204,146,76,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_LOW",
      command: [183,1,5,15,2,34,1,223,13,111,6,18,2,171,4,37,2,0,40,49,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,231,159,249,36,146,127,255,249,39,254,73,255,255,63,159,255,242,73,36,194],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_LOW",
      command: [183,1,5,17,2,35,1,226,13,79,6,22,2,170,4,58,2,32,40,19,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,243,159,249,36,146,127,255,249,39,254,73,255,255,63,159,255,243,249,8],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_LOW",
      command: [183,1,5,20,2,32,1,218,13,100,6,23,2,167,4,27,2,34,40,21,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,228,231,254,73,36,159,255,254,73,255,146,127,255,207,231,255,252,159,144,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_LOW",
      command: [183,1,5,16,2,32,1,221,13,104,6,24,2,164,4,52,2,25,40,16,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,249,159,249,36,146,127,255,249,39,254,73,255,255,63,159,255,243,62,66],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_LOW",
      command: [183,1,5,18,2,34,1,241,13,99,6,17,2,156,4,63,2,28,40,19,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,230,103,254,73,36,159,255,254,73,255,146,127,255,207,231,255,252,147,228,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_LOW",
      command: [183,1,5,15,2,31,1,223,13,104,6,31,2,172,4,36,2,29,40,25,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,242,103,254,73,36,159,255,254,73,255,146,127,255,207,231,255,252,231,144,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_LOW",
      command: [183,1,5,16,2,30,1,243,13,100,6,25,2,169,4,61,2,25,40,27,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,228,153,255,146,73,39,255,255,146,127,228,159,255,243,249,255,255,38,121,8],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_LOW",
      command: [183,1,5,16,2,33,1,218,13,108,6,28,2,168,4,58,2,27,40,19,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,252,159,249,36,146,127,255,249,39,254,73,255,255,63,159,255,243,39,144,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_LOW",
      command: [183,1,5,22,2,33,1,227,13,71,6,29,2,170,4,32,2,37,40,26,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,231,39,254,73,36,159,255,254,73,255,146,127,255,207,231,255,252,146,121,8],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_LOW",
      command: [183,1,5,16,2,32,1,244,13,99,6,20,2,169,4,51,2,254,39,23,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,243,39,254,73,36,159,255,254,73,255,146,127,255,207,231,255,252,243,144,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_LOW",
      command: [183,1,5,19,2,31,1,221,13,99,6,31,2,168,4,58,2,25,40,21,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,228,201,255,146,73,39,255,255,146,127,228,159,255,243,249,255,255,39,57,8],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_LOW",
      command: [183,1,5,18,2,33,1,223,13,102,6,27,2,170,4,31,2,38,40,25,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,249,39,254,73,36,159,255,254,73,255,146,127,255,207,231,255,252,204,228,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_LOW",
      command: [183,1,5,16,2,29,1,241,13,108,6,27,2,169,4,61,2,34,40,26,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,230,73,255,146,73,39,255,255,146,127,228,159,255,243,249,255,255,36,206,66],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_LOW",
      command: [183,1,5,18,2,33,1,219,13,100,6,29,2,169,4,53,2,30,40,16,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,242,73,255,146,73,39,255,255,146,127,228,159,255,243,249,255,255,57,57,8],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_MID",
      command: [183,1,5,17,2,33,1,219,13,103,6,30,2,167,4,33,2,29,40,19,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,254,127,228,146,76,255,255,228,159,249,39,255,252,254,127,255,204,147,144,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_MID",
      command: [183,1,5,19,2,34,1,223,13,76,6,18,2,169,4,53,2,5,40,17,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,231,159,249,36,147,63,255,249,39,254,73,255,255,63,159,255,242,73,57,8],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_MID",
      command: [183,1,5,15,2,33,1,221,13,105,6,27,2,169,4,60,2,27,40,21,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,243,159,249,36,147,63,255,249,39,254,73,255,255,63,159,255,243,230,66],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_MID",
      command: [183,1,5,17,2,33,1,225,13,98,6,34,2,168,4,62,2,27,40,20,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,228,231,254,73,36,207,255,254,73,255,146,127,255,207,231,255,252,158,100,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_MID",
      command: [183,1,5,18,2,32,1,222,13,102,6,20,2,164,4,50,2,24,40,15,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,249,159,249,36,147,63,255,249,39,254,73,255,255,63,159,255,243,57,144,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_MID",
      command: [183,1,5,15,2,33,1,221,13,106,6,29,2,168,4,38,2,25,40,13,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,230,103,254,73,36,207,255,254,73,255,146,127,255,207,231,255,252,147,153,8],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_MID",
      command: [183,1,5,19,2,35,1,214,13,83,6,34,2,169,4,56,2,35,40,15,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,242,103,254,73,36,207,255,254,73,255,146,127,255,207,231,255,252,230,100,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_MID",
      command: [183,1,5,18,2,33,1,235,13,105,6,29,2,168,4,34,2,33,40,14,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,228,153,255,146,73,51,255,255,146,127,228,159,255,243,249,255,255,38,102,66],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_MID",
      command: [183,1,5,17,2,32,1,221,13,106,6,21,2,163,4,35,2,24,40,14,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,252,159,249,36,147,63,255,249,39,254,73,255,255,63,159,255,243,38,100,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_MID",
      command: [183,1,5,18,2,33,1,229,13,103,6,21,2,170,4,46,2,29,40,20,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,231,39,254,73,36,207,255,254,73,255,146,127,255,207,231,255,252,146,102,66],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_MID",
      command: [183,1,5,17,2,31,1,223,13,97,6,32,2,169,4,57,2,28,40,18,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,243,39,254,73,36,207,255,254,73,255,146,127,255,207,231,255,252,242,100,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_MID",
      command: [183,1,5,16,2,31,1,224,13,106,6,28,2,169,4,51,2,33,40,17,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,228,201,255,146,73,51,255,255,146,127,228,159,255,243,249,255,255,39,38,66],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_MID",
      command: [183,1,5,20,2,33,1,225,13,77,6,25,2,170,4,52,2,31,40,21,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,249,39,254,73,36,207,255,254,73,255,146,127,255,207,231,255,252,204,153,8],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_MID",
      command: [183,1,5,17,2,35,1,221,13,100,6,28,2,170,4,57,2,30,40,18,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,230,73,255,146,73,51,255,255,146,127,228,159,255,243,249,255,255,36,201,144,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_MID",
      command: [183,1,5,15,2,32,1,225,13,108,6,24,2,170,4,49,2,29,40,23,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,242,73,255,146,73,51,255,255,146,127,228,159,255,243,249,255,255,57,38,66],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_HIGH",
      command: [183,1,4,17,2,32,1,253,13,110,6,17,2,168,4,53,2,25,40,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,254,127,228,146,73,63,255,249,39,254,73,255,255,63,159,255,243,36,153,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_HIGH",
      command: [183,1,4,19,2,34,1,221,13,100,6,26,2,170,4,37,2,25,40,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,231,159,249,36,146,79,255,254,73,255,146,127,255,207,231,255,252,146,73,146],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_HIGH",
      command: [183,1,4,17,2,30,1,244,13,105,6,31,2,171,4,33,2,30,40,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,243,159,249,36,146,79,255,254,73,255,146,127,255,207,231,255,252,252,146],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_HIGH",
      command: [183,1,5,16,2,33,1,226,13,109,6,25,2,169,4,41,2,30,40,127,2,12,1,103,255,159,228,156,255,255,255,254,79,197,152,127,231,249,39,63,255,57,158,78,127,228,146,73,63,255,249,39,254,73,255,255,63,159,255,242,124,146],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_HIGH",
      command: [183,1,5,17,2,41,1,219,13,109,6,20,2,170,4,40,2,24,40,22,2,121,2,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,249,159,249,36,146,79,255,254,73,255,146,127,255,207,231,255,252,207,36,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_HIGH",
      command: [183,1,4,12,2,34,1,227,13,112,6,24,2,167,4,54,2,30,40,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,230,103,254,73,36,147,255,255,146,127,228,159,255,243,249,255,255,36,242,72],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_HIGH",
      command: [183,1,4,17,2,34,1,239,13,109,6,19,2,169,4,35,2,25,40,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,242,103,254,73,36,147,255,255,146,127,228,159,255,243,249,255,255,57,201,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_HIGH",
      command: [183,1,4,15,2,37,1,246,13,110,6,17,2,170,4,60,2,24,40,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,228,153,255,146,73,36,255,255,228,159,249,39,255,252,254,127,255,201,156,146],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_HIGH",
      command: [183,1,4,17,2,34,1,241,13,100,6,24,2,171,4,58,2,34,40,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,252,159,249,36,146,79,255,254,73,255,146,127,255,207,231,255,252,201,201,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_HIGH",
      command: [183,1,4,16,2,36,1,227,13,108,6,21,2,170,4,37,2,33,40,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,231,39,254,73,36,147,255,255,146,127,228,159,255,243,249,255,255,36,156,146],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_HIGH",
      command: [183,1,4,16,2,38,1,251,13,112,6,20,2,168,4,37,2,23,40,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,243,39,254,73,36,147,255,255,146,127,228,159,255,243,249,255,255,60,201,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_HIGH",
      command: [183,1,4,16,2,35,1,223,13,101,6,25,2,168,4,31,2,34,40,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,228,201,255,146,73,36,255,255,228,159,249,39,255,252,254,127,255,201,204,146],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_HIGH",
      command: [183,1,4,14,2,42,1,243,13,120,6,15,2,170,4,31,2,36,40,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,249,39,254,73,36,147,255,255,146,127,228,159,255,243,249,255,255,51,50,72],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_HIGH",
      command: [183,1,4,18,2,36,1,219,13,105,6,24,2,168,4,36,2,24,40,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,230,73,255,146,73,36,255,255,228,159,249,39,255,252,254,127,255,201,51,36,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_HIGH",
      command: [183,1,4,18,2,37,1,222,13,99,6,23,2,169,4,39,2,30,40,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,153,242,73,255,146,73,36,255,255,228,159,249,39,255,252,254,127,255,206,76,146],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_MID",
      fan: "AC_FAN_AUTO",
      command: [183,1,4,16,2,36,1,225,13,110,6,28,2,173,4,37,2,23,40,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,159,249,39,249,36,153,159,255,249,39,254,73,255,255,63,159,255,243,39,146],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_HIGH",
      fan: "AC_FAN_AUTO",
      command: [183,1,4,17,2,33,1,222,13,108,6,32,2,169,4,52,2,25,40,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,159,62,73,254,73,38,103,255,254,73,255,146,127,255,207,231,255,254,73,228,128],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_LOW",
      fan: "AC_FAN_AUTO",
      command: [183,1,4,17,2,36,1,219,13,101,6,20,2,168,4,48,2,30,40,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,159,36,146,73,254,73,38,103,255,254,73,255,146,127,255,207,231,255,255,38,100,128],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_MID",
      fan: "AC_FAN_LOW",
      command: [183,1,4,16,2,36,1,222,13,108,6,19,2,170,4,33,2,23,40,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,159,249,39,249,36,146,127,255,249,39,254,73,255,255,63,159,255,243,36,242],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_HIGH",
      fan: "AC_FAN_LOW",
      command: [183,1,4,17,2,34,1,246,13,102,6,18,2,170,4,34,2,26,40,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,159,62,73,254,73,36,159,255,254,73,255,146,127,255,207,231,255,254,73,60,128],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_LOW",
      fan: "AC_FAN_LOW",
      command: [183,1,4,20,2,33,1,224,13,99,6,24,2,167,4,49,2,25,40,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,159,36,146,73,254,73,36,159,255,254,73,255,146,127,255,207,231,255,255,36,156,128],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_MID",
      fan: "AC_FAN_MID",
      command: [183,1,4,15,2,34,1,220,13,110,6,19,2,171,4,52,2,27,40,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,159,249,39,249,36,147,63,255,249,39,254,73,255,255,63,159,255,243,36,156,128],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_HIGH",
      fan: "AC_FAN_MID",
      command: [183,1,4,17,2,30,1,244,13,97,6,28,2,166,4,64,2,0,40,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,159,62,73,254,73,36,207,255,254,73,255,146,127,255,207,231,255,254,73,39,32],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_LOW",
      fan: "AC_FAN_MID",
      command: [183,1,4,17,2,30,1,252,13,101,6,28,2,166,4,34,2,36,40,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,159,36,146,73,254,73,36,207,255,254,73,255,146,127,255,207,231,255,255,36,204,128],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_MID",
      fan: "AC_FAN_HIGH",
      command: [183,1,4,16,2,36,1,225,13,106,6,17,2,171,4,32,2,32,40,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,159,249,39,249,36,146,79,255,254,73,255,146,127,255,207,231,255,252,201,51,32],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_HIGH",
      fan: "AC_FAN_HIGH",
      command: [183,1,4,17,2,32,1,225,13,101,6,21,2,167,4,48,2,34,40,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,159,62,73,254,73,36,147,255,255,146,127,228,159,255,243,249,255,255,146,76,200],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_LOW",
      fan: "AC_FAN_HIGH",
      command: [183,1,4,18,2,32,1,229,13,99,6,22,2,152,4,41,2,25,40,103,255,159,228,156,255,255,255,254,79,197,159,254,127,146,115,255,243,159,36,146,73,254,73,36,147,255,255,146,127,228,159,255,243,249,255,255,201,36,200],
    },
    ]
};

export default PANASONIC_A75C3712
